import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { trendingTags } from '@/mocks/categories';
import { useEffect } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading text-foreground-950 mb-4">分类不存在</h1>
            <p className="text-foreground-500">找不到该分类，请检查链接是否正确。</p>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <div className="pt-20 pb-4 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>
        </div>

        {/* Category Header */}
        <section className="bg-background-50 pb-10">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-accent-500 flex items-center justify-center">
                <i className={`${category.icon} text-2xl text-background-50`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-4xl font-heading font-black text-foreground-950">
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-500 mt-1">{category.description}</p>
              </div>
            </div>
            {/* Tags */}
            <div className="flex flex-wrap gap-2 mt-4">
              {trendingTags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs bg-background-100 text-foreground-600 px-3 py-1.5 rounded-full hover:bg-accent-100 hover:text-accent-800 transition-colors cursor-pointer"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* Article List */}
        <section className="py-10 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <p className="text-sm text-foreground-500">
                共 <strong className="text-foreground-950">{categoryArticles.length}</strong> 篇爆料
              </p>
              <div className="flex items-center gap-2">
                <button className="bg-accent-500 text-background-50 text-xs px-4 py-1.5 rounded-full font-medium whitespace-nowrap cursor-pointer">
                  最新
                </button>
                <button className="bg-background-50 text-foreground-600 text-xs px-4 py-1.5 rounded-full font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  最热
                </button>
              </div>
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类下暂无爆料，敬请期待。</p>
              </div>
            )}
          </div>
        </section>
      </main>

      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category.name} - 51吃瓜网站`,
            description: category.description,
            url: `http://kanpian51.cn/category/${category.slug}`,
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://kanpian51.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: category.name,
                },
              ],
            },
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: categoryArticles.map((a, i) => ({
                '@type': 'ListItem',
                position: i + 1,
                url: `http://kanpian51.cn/article/${a.id}`,
                name: a.title,
              })),
            },
          }),
        }}
      />

      <Footer />
    </>
  );
}